export default __webpack_public_path__ + "assets/images/a7abb9e92d4e6398114472ec8761b97d.png";